import * as XLSX from 'xlsx';

const FILE_SAVE_NOTIFY_DELAY_MS = 600;

export function triggerFileDownload(blob: Blob, filename: string): void {
  if (
    (window.navigator as any) &&
    (window.navigator as any).msSaveOrOpenBlob
  ) {
    (window.navigator as any).msSaveOrOpenBlob(blob, filename);
    return;
  }

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);
  const url = window.URL.createObjectURL(blob);
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(anchor);
}

export function scheduleAfterFileSave(callback: () => void): void {
  requestAnimationFrame(() => {
    setTimeout(callback, FILE_SAVE_NOTIFY_DELAY_MS);
  });
}

export function downloadXlsxWorkbook(
  workbook: XLSX.WorkBook,
  filename: string,
  onSaved?: () => void,
): void {
  const fileBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([fileBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  triggerFileDownload(blob, filename);
  if (onSaved) {
    scheduleAfterFileSave(onSaved);
  }
}
